import axios from "axios";
import { API_BASE } from "./api";

// Portal client uses its own token stored under different key
// to avoid conflicting with admin/collaborator session.
export const PORTAL_TOKEN_KEY = "cm_portal_token";

export const portalApi = axios.create({
  baseURL: API_BASE,
  withCredentials: false, // portal usa apenas Bearer token
});

portalApi.interceptors.request.use((config) => {
  const tok = localStorage.getItem(PORTAL_TOKEN_KEY);
  if (tok) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${tok}`;
  }
  return config;
});

portalApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(PORTAL_TOKEN_KEY);
      localStorage.removeItem("cm_portal_client");
      if (window.location.pathname.startsWith("/portal") && window.location.pathname !== "/portal/login") {
        window.location.href = "/portal/login";
      }
    }
    return Promise.reject(error);
  },
);

export function portalLogout() {
  localStorage.removeItem(PORTAL_TOKEN_KEY);
  localStorage.removeItem("cm_portal_client");
}

export function getPortalClient() {
  try {
    const raw = localStorage.getItem("cm_portal_client");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setPortalSession(token, client) {
  localStorage.setItem(PORTAL_TOKEN_KEY, token);
  localStorage.setItem("cm_portal_client", JSON.stringify(client));
}

export function isPortalAuthenticated() {
  return !!localStorage.getItem(PORTAL_TOKEN_KEY);
}
